//animation variables
const animationDuration = 2000;
const frameDuration = 1000 / 60;
const totalFrames = Math.round(animationDuration / frameDuration);

function animateCountUp(el, number) {
  let frame = 0;
  const countTo = parseInt(number, 10) + 1;

  const counter = setInterval(() => {
    frame++;
    const progress = easeOut(frame / totalFrames);
    const currentCount = Math.round(countTo * progress);

    if (countTo !== currentCount) {
      el.innerHTML = `${currentCount}%`;
    }

    if (frame === totalFrames) {
      clearInterval(counter);
    }
  }, frameDuration);
}

function easeOut(t) {
  return t * (2 - t);
}
